"use client";

import { ImageSectionPreview } from "@/scott/ui/blocks/image-section/image-section.preview";
import { VideoBlockPreview } from "@/scott/ui/blocks/video/video.preview";
import type { SectionMediaPageBlock } from "@/types/page-block";
import { MediaSection } from "./media-section";

export function MediaSectionPreview(props: Readonly<SectionMediaPageBlock>) {
  return (
    <MediaSection
      {...props}
      ImageComponent={ImageSectionPreview}
      VideoComponent={VideoBlockPreview}
    />
  );
}
